
































































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { storePersetujuanKb } from "@/store/modules/PersetujuanKbStore";
import PersetujuanKbSvc from "@/services/PersetujuanKb";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { alasanTtdMengunciHapus, slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";

@Component({
  components: { CardModalTtd },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPersetujuanKb extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: 'ranap' }) context!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean { return this.isReadOnly(); }

  showForm = false;
  isEditing = false;
  selectedItem: any = null;
  modalTtd = false;
  modalMark = false;
  markRole = '';
  markName = '';
  signRole = '';
  saving = false;
  deleting = false;
  formValid = false;
  menuTanggal = false;
  menuJam = false;
  menuHpht = false;
  panels: number[] = [0, 1, 2, 3, 4, 5];

  form: any = this.getEmptyForm();

  tableHeaders = [
    { text: "Kode", value: "metode_kode", width: "70" },
    { text: "Metode", value: "metode_nama" },
    { text: "Tanggal", value: "tgl_tanda_tangan", width: "120" },
    { text: "Keputusan", value: "is_setuju", width: "100" },
    { text: "Status TTD", value: "status_ttd", width: "120" },
  ];

  jenisAkseptorOptions = [
    { text: "Akseptor Baru", value: "baru" },
    { text: "Akseptor Aktif", value: "aktif" },
    { text: "Ganti Cara", value: "ganti_cara" },
    { text: "KB Pasca Persalinan", value: "kb_pp" },
    { text: "KB Pasca Keguguran", value: "kb_pk" },
  ];

  statusHamilOptions = [
    { text: "Negatif", value: "negatif" },
    { text: "Positif", value: "positif" },
    { text: "Tidak Dapat Dipastikan", value: "tdk_dpt_dipastikan" },
    { text: "Pasca Persalinan", value: "pasca_persalinan" },
    { text: "Pasca Keguguran", value: "pasca_keguguran" },
  ];

  mecOptions = [
    { text: "Kategori 1 — Tidak ada batasan", value: 1 },
    { text: "Kategori 2 — Umumnya dapat digunakan", value: 2 },
    { text: "Kategori 3 — Tidak direkomendasikan", value: 3 },
    { text: "Kategori 4 — KONTRAINDIKASI", value: 4 },
  ];

  satutujuSteps = [
    { key: "sa", label: "SA — Sapa/Salam" },
    { key: "t",  label: "T — Tanya" },
    { key: "u",  label: "U — Uraikan" },
    { key: "tu", label: "TU — banTU memilih" },
    { key: "j",  label: "J — Jelaskan" },
    { key: "u2", label: "U — kUnjungan ulang" },
  ];

  mounted() {
    storePersetujuanKb.getByRegister(this.register);
    storePersetujuanKb.loadMetodeList();
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  getEmptyForm() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: userModule.user?.unit_id || null,
      context: this.context,
      jenis_akseptor: '',
      jumlah_anak_hidup: 0,
      jumlah_anak_meninggal: null,
      umur_anak_terkecil_bulan: null,
      sedang_menyusui: false,
      hpht: null,
      status_kehamilan: '',
      pasangan_nama: '',
      pasangan_nik: '',
      pasangan_hubungan: null,
      pasangan_alamat: '',
      konseling_satutuju: { sa: false, t: false, u: false, tu: false, j: false, u2: false },
      mec_kategori: null,
      mec_catatan: '',
      konseling_user_id: null,
      kode_metode: null,
      lateralitas: null,
      indikasi_klinis: '',
      is_setuju: null,
      pernyataan_sukarela: true,
      pernyataan_memahami_risiko: true,
      pernyataan_hak_cabut: true,
      akseptor_nama: storePasien.identitasPasien?.nama || '',
      operator_user_id: null,
      dpjp_user_id: null,
      tempat_tanda_tangan: 'Bantul',
      tgl_tanda_tangan: localISODate(),
      jam_tanda_tangan: new Date().toTimeString().substr(0, 5),
    };
  }

  get loading() { return storePersetujuanKb.loading; }
  get items() { return storePersetujuanKb.items; }
  get metodeMap() { return storePersetujuanKb.metodeMap; }
  get stateuser() { return userModule.user; }
  get dokterList() { return storeDokter.listAll; }

  get groupedMetode() {
    const groups: Record<string, any[]> = {};
    Object.entries(this.metodeMap).forEach(([kode, m]: any) => {
      const k = m.kelompok;
      if (!groups[k]) groups[k] = [];
      groups[k].push({ kode: Number(kode), ...m });
    });
    return groups;
  }

  kelompokLabel(k: string) {
    return ({
      pemberian: 'Pemberian (Suntik)',
      pemasangan: 'Pemasangan (Implant/IUD)',
      cabut_pasang: 'Pencabutan + Pemasangan Ulang',
      operatif: 'Operatif (Kontrasepsi Mantap)',
      pencabutan: 'Pencabutan (Tanpa Pemasangan Ulang)',
      rekanalisasi: 'Rekanalisasi',
    } as any)[k] || k;
  }

  kelompokColor(k: string) {
    return ({
      operatif: 'red--text',
      rekanalisasi: 'red--text',
    } as any)[k] || 'primary--text';
  }

  get selectedMeta() {
    if (!this.form.kode_metode) return null;
    return this.metodeMap[this.form.kode_metode] || null;
  }

  get isKontap() {
    return this.selectedMeta?.kontap === true;
  }

  get needsLateralitas() {
    if (!this.selectedMeta) return false;
    return ['pemasangan', 'cabut_pasang', 'pencabutan'].includes(this.selectedMeta.kelompok)
      && this.selectedMeta.nama?.toLowerCase().includes('implant');
  }

  get statusHamilHint() {
    const k = this.form.kode_metode;
    if ([5, 6, 9, 10, 11].includes(k)) {
      return 'IUD & Tubektomi memerlukan status hamil negatif (WHO MEC 4)';
    }
    return '';
  }

  get competencyWarning() {
    if (!this.selectedMeta || !this.form.operator_user_id) return null;
    const dokter = this.dokterList.find((d: any) => d.id === this.form.operator_user_id);
    if (!dokter) return null;
    const need = this.selectedMeta.kompetensi || [];
    // Soft-check: hanya warning, tidak blokir. Real validation by profesi user perlu profesi codeset.
    if (this.selectedMeta.kontap) {
      return `Tindakan ini memerlukan kompetensi: ${need.join(' / ')}. Pastikan operator memiliki sertifikat kompetensi yang sesuai (PKMI/POGI/IAUI).`;
    }
    return null;
  }

  selectMetode(kode: number) {
    this.form.kode_metode = kode;
    // reset lateralitas jika tidak relevan
    if (!this.needsLateralitas) this.form.lateralitas = null;
  }

  selectItem(item: any) { this.selectedItem = item; }

  openCreateForm() {
    this.form = this.getEmptyForm();
    this.showForm = true;
  }

  startEdit() {
    const c = this.selectedItem;
    this.form = {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: c.unit_id || this.stateuser?.unit_id,
      context: c.context || this.context,
      jenis_akseptor: c.jenis_akseptor,
      jumlah_anak_hidup: c.jumlah_anak_hidup,
      jumlah_anak_meninggal: c.jumlah_anak_meninggal,
      umur_anak_terkecil_bulan: c.umur_anak_terkecil_bulan,
      sedang_menyusui: c.sedang_menyusui,
      hpht: c.hpht,
      status_kehamilan: c.status_kehamilan,
      pasangan_nama: c.pasangan_nama || '',
      pasangan_nik: c.pasangan_nik || '',
      pasangan_hubungan: c.pasangan_hubungan,
      pasangan_alamat: c.pasangan_alamat || '',
      konseling_satutuju: c.konseling_satutuju || { sa: false, t: false, u: false, tu: false, j: false, u2: false },
      mec_kategori: c.mec_kategori,
      mec_catatan: c.mec_catatan || '',
      konseling_user_id: c.konselor?.id || null,
      kode_metode: c.kode_metode,
      lateralitas: c.lateralitas,
      indikasi_klinis: c.indikasi_klinis || '',
      is_setuju: c.is_setuju,
      pernyataan_sukarela: c.pernyataan_sukarela,
      pernyataan_memahami_risiko: c.pernyataan_memahami_risiko,
      pernyataan_hak_cabut: c.pernyataan_hak_cabut,
      akseptor_nama: c.akseptor_nama,
      operator_user_id: c.operator?.id || null,
      dpjp_user_id: c.dpjp?.id || null,
      tempat_tanda_tangan: c.tempat_tanda_tangan || 'Bantul',
      tgl_tanda_tangan: c.tgl_tanda_tangan,
      jam_tanda_tangan: c.jam_tanda_tangan,
    };
    this.isEditing = true;
  }

  cancelForm() {
    this.showForm = false;
    this.isEditing = false;
    this.form = this.getEmptyForm();
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = { ...this.form };
      let resp;
      if (this.isEditing && this.selectedItem) {
        resp = await PersetujuanKbSvc.update(this.selectedItem.id, payload);
      } else {
        resp = await PersetujuanKbSvc.create(payload);
      }
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Persetujuan KB berhasil disimpan");
        this.showForm = false;
        this.isEditing = false;
        this.selectedItem = null;
        this.form = this.getEmptyForm();
        storePersetujuanKb.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  // Permissions
  get canEdit() {
    if (this.readOnly) return false;
    return this.selectedItem && !this.selectedItem.is_locked;
  }
  get canDelete() {
    if (this.readOnly || !this.selectedItem) return false;
    const item = this.selectedItem;
    return !alasanTtdMengunciHapus(
      item.creator_user_id,
      [
        ...slotTandaTanganDokumen(item.signed_operator, item.signature_operator),
        ...slotTandaTanganDokumen(item.signed_dpjp, item.signature_dpjp),
        ...slotTandaTanganDokumen(item.signed_saksi_rs, item.signature_saksi_rs),
        { ditandatangani: item.signed_akseptor, penandaTanganId: null },
        { ditandatangani: item.signed_pasangan, penandaTanganId: null },
        { ditandatangani: item.signed_saksi_keluarga, penandaTanganId: null }
      ],
      userModule.user?.id
    );
  }
  get canSignOperator() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_operator) return false;
    return this.selectedItem.operator?.id == this.stateuser?.id;
  }
  get canSignDpjp() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_dpjp) return false;
    return this.selectedItem.dpjp?.id == this.stateuser?.id;
  }
  get canSignSaksiRs() {
    if (this.readOnly || !this.selectedItem) return false;
    if (this.selectedItem.signed_saksi_rs) return false;
    if (this.selectedItem.saksi_rs && this.selectedItem.saksi_rs.id != this.stateuser?.id) return false;
    return true;
  }
  get canMarkAkseptor() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_akseptor;
  }
  get canMarkPasangan() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_pasangan;
  }
  get canMarkSaksiKeluarga() {
    return !this.readOnly && this.selectedItem && !this.selectedItem.signed_saksi_keluarga;
  }

  // Labels
  jenisAkseptorLabel(v: string) { return this.jenisAkseptorOptions.find(o => o.value === v)?.text || v; }
  statusHamilLabel(v: string) { return this.statusHamilOptions.find(o => o.value === v)?.text || v; }

  get markLabel() {
    return ({
      akseptor: 'Akseptor',
      pasangan: 'Suami/Istri',
      saksi_keluarga: 'Saksi Keluarga',
    } as any)[this.markRole] || '';
  }

  openMarkAkseptor() {
    this.markRole = 'akseptor';
    this.markName = this.selectedItem?.akseptor_nama || '';
    this.modalMark = true;
  }
  openMarkPasangan() {
    this.markRole = 'pasangan';
    this.markName = this.selectedItem?.pasangan_nama || '';
    this.modalMark = true;
  }
  openMarkSaksiKeluarga() {
    this.markRole = 'saksi_keluarga';
    this.markName = this.selectedItem?.saksi_keluarga_nama || '';
    this.modalMark = true;
  }

  async submitMark() {
    const fns: Record<string, Function> = {
      akseptor: (id, payload) => PersetujuanKbSvc.markAkseptor(id, { akseptor_nama: payload }),
      pasangan: (id, payload) => PersetujuanKbSvc.markPasangan(id, { pasangan_nama: payload }),
      saksi_keluarga: (id, payload) => PersetujuanKbSvc.markSaksiKeluarga(id, { saksi_keluarga_nama: payload }),
    };
    const fn = fns[this.markRole];
    if (!fn) return;
    const resp = await fn(this.selectedItem.id, this.markName);
    if (resp.data.status == "1") {
      this.modalMark = false;
      appModule.NoticeDelay(resp.data.message);
      this.selectedItem = null;
      storePersetujuanKb.getByRegister(this.register);
    }
  }

  openTtd(role: string) {
    this.signRole = role;
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    const fns: Record<string, Function> = {
      operator: PersetujuanKbSvc.signOperator,
      dpjp: PersetujuanKbSvc.signDpjp,
      saksi_rs: PersetujuanKbSvc.signSaksiRs,
    };
    const labels: Record<string, string> = {
      operator: 'Pemberi Pelayanan',
      dpjp: 'DPJP',
      saksi_rs: 'Saksi RS',
    };
    const fn = fns[this.signRole];
    if (!fn) return;
    const resp = await fn(this.selectedItem.id, { password });
    if (resp.data.status == "1") {
      this.modalTtd = false;
      appModule.NoticeDelay(`Berhasil Tanda Tangan ${labels[this.signRole]}`);
      appModule.addMsgTtd("");
      this.selectedItem = null;
      storePersetujuanKb.getByRegister(this.register);
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalTtd = true;
    }
  }

  cetakPdf() {
    PersetujuanKbSvc.print(this.selectedItem.id);
  }

  async remove() {
    if (!this.canDelete) return;
    if (!confirm("Anda yakin akan menghapus Persetujuan KB ini?")) return;
    this.deleting = true;
    try {
      const resp = await PersetujuanKbSvc.destroy(this.selectedItem.id);
      if (resp?.status == 1) {
        appModule.NoticeDelay(resp.message);
        this.selectedItem = null;
        storePersetujuanKb.getByRegister(this.register);
      }
    } finally {
      this.deleting = false;
    }
  }
}
